import { Box, Button, DialogContent, keyframes, TextField, Typography } from "@mui/material";
import GlobalDialogContent from "../GlobalDialogContent";
import { useState } from "react";
import { StoreEventsList } from "../../../utils/services/project/project";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { showSnackbar } from "../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../redux/reducer/dialogSlice";
import { setModuleRefresh } from "../../../redux/reducer/registration/RefreshSlice";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import PageLang from "../../../config/page.languge";

const PublishEvent = () => {
  const eventId = useSelector((state: RootState) => state.dialog.payload);
  const dispatch = useDispatch();
  const lang=useSelector((state:RootState)=>state.lang.language)
  const [comment, setComment] = useState("");

  const storeConfirmInterest = async () => {
    if(comment){   
     const reqPayload = {
        uuid: eventId?.uuid,
        comment: comment,
    }
    const { code, message } = await StoreEventsList(reqPayload);
    if (code === 200) {      
      dispatch(closeDialog());
      dispatch(setModuleRefresh({ moduleName: 'publishEvent_list', refresh: true }));
      dispatch(showSnackbar({ type: 'success', message: message || 'Registered for Integrested in this Project.' }))
    } else {
      dispatch(showSnackbar({ type: 'error', message: message }))
    }} else {
        dispatch(showSnackbar({ type: 'error', message: PageLang?.diaLogues?.Event?.publish?.pleaseEnterPublishComment[lang] }))

    }
  }

  const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

  return (
    <>
      <GlobalDialogContent
        dialogBody={
          <>
            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ display: 'flex', textAlign: 'left', }}>
                    <Box sx={{ animation: `${floatAnimation} 3s ease-in-out infinite`, }}>
                        <img src="/announce.png" alt="Interested in Project Icon" width="100" height="100" style={{ filter: "drop-shadow(3px 5px 1px rgba(0,0,0,0.3))" }} />
                    </Box>
                    <Typography variant="h5" sx={{ textAlign: 'left ', pl: 5, pt: 2 }}>
                        {PageLang?.diaLogues.Event.publish.publishEventConfirmation[lang]}{" "}
                        <strong>{eventId?.title}</strong> {PageLang?.diaLogues.Event.publish.thisEvent[lang]} ?
                    </Typography>
                </Box>
                <TextField label={PageLang?.diaLogues?.Event?.publish?.enterEventPublishComment[lang]}
                    variant="outlined"
                    fullWidth
                    multiline
                    size="small"
                    minRows={2}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </DialogContent>
            </>
            }
        dialogFooter={
          <>
            <Button onClick={storeConfirmInterest} variant="contained" color="primary" endIcon={<RecordVoiceOverIcon />}>
              {PageLang?.diaLogues?.Event?.publish?.publish[lang]}
            </Button>
          </>
        }
      />
    </>
  );
};

export default PublishEvent;
